import { Component, OnInit, Inject, ViewContainerRef } from "@angular/core";
import {
  OrdinalDateAdapter,
  ORD_DATE_FORMATS,
  OrdinalDateParse,
} from "../../../adapters/ordinal-date-adapter";
import { GETInventoryService } from "../../../services/inventory.service";
import { ComponentRepairData } from "../../../entities/component/model";
import {
  GenericIdName,
  ComponentVM,
} from "../../../setup-implement/setup-implement.model";
import { ErrorCode, ErrorMessages } from "../../../entities/global/error-codes";
import { SetupImplementService } from "../../../setup-implement/setup-implement.service";
import { UpdateSMUReadingModel } from "../../equipment-details.model";
import { EquipmentDetailsService } from "../../equipment-details.service";
import { NotificationsService } from "angular2-notifications";
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { ImplementDetailsService } from "../../../implement-details/implement-details.service";
import { ConfirmationBoxComponent } from "../../../../../shared/confirmation-box/confirmation-box.component";

@Component({
  selector: "implement-action",
  templateUrl: "./implement-action.component.html",
  styleUrls: ["./implement-action.component.scss"],
  providers: [
    {
      provide: DateAdapter,
      useClass: OrdinalDateAdapter,
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: ORD_DATE_FORMATS,
    },
  ],
})
export class ImplementActionComponent implements OnInit {
  ord: OrdinalDateParse = new OrdinalDateParse();

  jobsiteId: number;
  jobsiteName: string;
  equipmentId: number;
  customerId: number;

  implementList: GenericIdName[] = [];
  componentList: ComponentVM[] = [];
  CopycomponentList: ComponentVM[] = [];

  componentTypes: GenericIdName[] = [];

  selectedImplement: number;
  selectedComponent: number;
  selectedComponentType: number[];

  cost: number;
  currentSmu: number;
  eventDate: Date = new Date();
  comment: string;
  actionType: number = 1;
  recordRepairData: ComponentRepairData;
  recordReplaceData: ComponentRepairData;
  savingChanges: boolean = false;

  // Toggle
  minDateForAction: Date = new Date();
  maxDateForAction: Date = new Date();

  // Replace
  minDate1: Date = new Date();
  maxDate1: Date = new Date();

  // Repair
  minDate2: Date = new Date();
  maxDate2: Date = new Date();

  // Tooltips
  ttDate: string = "Click here to select a date.";
  ttComment: string = "You may enter a maximum of 256 characters.";

  cbAllComponentSelect: boolean = false;
  downtimeHrs: number = 0;

  TLabour_Hours: number = 0;
  TLabour_Cost: number = 0;
  TPart_Cost: number = 0;
  TMisc_Cost: number = 0;
  TTotal_Cost: number = 0;

  DLabour_Hours: number;
  DLabour_Cost: number;
  DPart_Cost: number;
  DMisc_Cost: number;
  DTotal_Cost: number;

  totalHrs: number = 0;
  totalLabour: number = 0;
  totalparts: number = 0;
  totalMisc: number = 0;
  totalcost: number = 0;
  hasChecked: boolean = true;
  activeUrl: string;
  hasDiffernce: boolean = false;
  isPendingAssetActions: boolean = false;
  removeActionData: boolean = false;
  pendingActionResponse: any;
  previousRemoveActionData: boolean = false;
  private _subscriptions: any;
  constructor(
    private dialogRef: MatDialogRef<ImplementActionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _equipment: EquipmentDetailsService,
    public _inventoryService: GETInventoryService,
    public _implementService: SetupImplementService,
    public toastr: NotificationsService,
    vcr: ViewContainerRef,
    private _moduleService: ImplementDetailsService,
    public _dialog: MatDialog,
    //public route: ActivatedRoute
  ) {}

  ngOnInit() {
    //this.activeUrl = this.route.snapshot.paramMap.get('implementId');
    //this.activeUrls = this.route.snapshot.paramMap.get('implementId');
    this.recordReplaceData = new ComponentRepairData();
    this.recordRepairData = new ComponentRepairData();
    this.recordRepairData.cost = 0;
    this.recordReplaceData.cost = 0;
    this.recordRepairData.comment = "";
    this.recordReplaceData.comment = "";
    this.eventDate = new Date();
    this.recordReplaceData.date = this.eventDate;
    this.recordRepairData.date = this.eventDate;
    console.log("this.data.implementId", this.data.implementId);

    if (this.data != null) {
      this.currentSmu = this.data.currentSmu;
      if (this.data.jobsiteId != null) {
        this.jobsiteId = this.data.jobsiteId;

        console.log("this.jobsiteId", this.jobsiteId);

        if (this.data.jobsiteName != null) {
          this.jobsiteName = this.data.jobsiteName;
        }
      }

      if (this.data.equipmentId != null) {
        this.equipmentId = this.data.equipmentId;
      }
      if (this.data.customerId != null) {
        this.customerId = this.data.customerId;
      }
      this.recordRepairData.smu = this.currentSmu;
      this.recordReplaceData.smu = this.currentSmu;
      this.isPendingAssetActions = this.data.IsPendingAssetActions;
      if (this.isPendingAssetActions) {
        this.removeActionData = true;
        this.previousRemoveActionData = this.removeActionData;
      }
    }

    if (this.jobsiteId != 0 && this.equipmentId == 0) {
      this._implementService
        .GetImplementsInInventory(this.jobsiteId)
        .subscribe((r) => {
          this.implementList = r;
          console.log("Drop down List", this.implementList);
          let selectedImplent = this.implementList.filter(
            (x) => x.Id == this.data.implementId,
          );
          this.selectedImplement = selectedImplent[0].Id;
          //this.selectedImplement = this.implementList[0].Id;
          console.log("Drop down List selected ", this.implementList[0].Id);
          this.implementSelected();
          this._inventoryService
            .returnMinDateForImplementEvent(this.selectedImplement.toString())
            .subscribe((response) => {
              if (response != "") {
                try {
                  this.minDate2 = new Date(response);
                } catch (ex) {
                  this.minDate2 = new Date();
                }
              }
            });
        });
    }
    if (this.jobsiteId != 0 && this.equipmentId != 0) {
      if (!this.isPendingAssetActions) {
        this._implementService
          .GetImplementsOnEquipment(this.equipmentId)
          .subscribe((r) => {
            this.implementList = r;
            console.log("Implement List  for dropdown", this.implementList);
            console.log("Implement List Length", this.implementList.length);
            let selectedImplent = this.implementList.filter(
              (x) => x.Id == this.data.implementId,
            );
            this.selectedImplement = selectedImplent[0].Id;
            this.implementSelected();
            this._inventoryService
              .returnMinDateForImplementEvent(this.selectedImplement.toString())
              .subscribe((response) => {
                if (response != "") {
                  try {
                    this.minDate2 = new Date(response);
                  } catch (ex) {
                    this.minDate2 = new Date();
                  }
                }
              });
          });
      } else {
        this._implementService
          .GetImplementsOnEquipment(this.equipmentId)
          .subscribe((r) => {
            this.implementList = r;

            const selectedImplent = this.implementList.find(
              (x) => x.Id == this.data.implementId,
            );

            if (selectedImplent) {
              this.selectedImplement = selectedImplent.Id;
            }

            this.loadComponentTypes();
          });
      }
    }
  }

  loadPendingActionData() {
    this._implementService
      .getInspMaintananceActions(this.data.implementId)
      .subscribe((response: string) => {
        const data = JSON.parse(response);

        this.pendingActionResponse = data;

        this.selectedImplement = data.get_auto;
        this.currentSmu = data.MeterReading;
        this.eventDate = new Date(data.InspectionDate);

        const ids = data.ComponentTypeIds
          ? data.ComponentTypeIds.split(",").map(Number)
          : [];

        console.log("ComponentTypeIds", data.ComponentTypeIds);
        console.log("ids", ids);

        this.selectedComponentType = ids;

        this.componentList = data.Components || [];

        this.componentList.forEach((x) => {
          x.selectComp = true;
        });
      });
  }

  onRemoveActionDataChanged(event: any) {
    const newValue = event.checked;
    const dialogRef = this._dialog.open(ConfirmationBoxComponent, {
      width: "450px",
      disableClose: true,
      data: {
         title: 'Confirm Action',
         message: newValue
          ? "Do you want to load pending action data?"
          : "Would you like to remove the pending action data?",
          button1: newValue ? null : 'Temporarily Remove',
          button2: newValue ? null : 'Permanently Remove',
          IsRemoveAction: newValue ? false : true
      },
    })
    dialogRef.afterClosed().subscribe((result) => {
      if (result?.confirmed) {
        this.previousRemoveActionData = newValue;
        if (newValue) {
          this.loadPendingActionData();
        } else {
          this.loadExistingData();
          if (result?.isPermanent) {
            this.removeActionDataPermanently();
          }
        }
      } else {
        this.removeActionData = this.previousRemoveActionData;
      }
    });
  }

  loadExistingData() {
    this.selectedComponentType = [];
    this.componentList = [];

    this._implementService
      .ReturnGETComponents(this.selectedImplement)
      .subscribe((result) => {
        this.CopycomponentList = result;
      });
  }

  removeActionDataPermanently() {
    this._implementService.updateMaintainanceActionData(this.data.implementId).subscribe(result => {
        if (result) {
            this.toastr.success("Pending action data removed permanently.");
        } else {
            this.toastr.error("Failed to remove pending action data permanently.");
        }
    });
  }

  doReplace() {
    this.minDateForAction = this.minDate1;
    this.maxDateForAction = this.maxDate1;
  }

  doRepair() {
    this.minDateForAction = this.minDate1;
    this.maxDateForAction = this.maxDate2;
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  SMUupdateSucess: boolean = false;
  updateSMU() {}

  toggleAllObsevations(v) {
    console.log("Select All", v);
    //this.componentList.forEach(c => c.selectComp = v);
    this.componentList.forEach((c) => {
      c.selectComp = v;
      c.Planned = v;
    });
    if (v == true) {
      this.componentList.map((x) => {
        this._inventoryService
          .returnMinDateForComponentReplace(x.Id.toString())
          .subscribe((response) => {
            if (response != "") {
              try {
                this.minDate1 = new Date(response);
                if (this.eventDate < this.minDate1) {
                  // console.log("this.action__", this.minDate1, this.eventDate)

                  x.ActionSucess = -1;
                  x.ActionMinDate = this.minDate1;
                  x.Error = "Action date should be greater than ";
                  this.DisabledSaveButton = true;
                  return;
                } else {
                  x.ActionSucess = 0;
                  x.ActionMinDate = null;
                  x.Error = "";
                }
              } catch (ex) {
                this.minDate1 = new Date();
              } finally {
                // this.minDateForAction = this.minDate1;
              }
            }
          });
      });
    }
  }

  arr_ReplaceComponents: ComponentVM[];
  arr_RepaprComponents: ComponentVM[];
  saveChangesNew() {
    if (this.savingChanges) {
      return;
    }

    let validation = this.validateData_New();
    this.savingChanges = true;

    if (validation == ErrorCode.VALIDATION_PASSED) {
      if (this.componentList.find((x) => x.selectComp == true)) {
        let updateModel = new UpdateSMUReadingModel();
        updateModel.currentReading = this.currentSmu;
        updateModel.dateReadSMU = this.eventDate;
        updateModel.equipmentId = this.equipmentId;
        updateModel.startDate = this.eventDate;
        updateModel.endDate = this.eventDate;
        updateModel.bcm = 0;
        updateModel.ton = 0;
        console.log("UpdateSMu", updateModel);

        if (this.equipmentId > 0) {
          this._equipment
            .changeSMUReadingAssetRepair(updateModel)
            .subscribe((succeeded) => {
              if (succeeded.m_Item1) {
                //replace selected component

                this.arr_ReplaceComponents = this.componentList.filter(
                  (x) => x.selectComp == true && x.ActionId == 1,
                );
                this.arr_RepaprComponents = this.componentList.filter(
                  (x) => x.selectComp == true && x.ActionId == 2,
                );

                const compReplaceRes = this.arr_ReplaceComponents.map(
                  async (x) => {
                    let replace = new ComponentRepairData();
                    replace.componentId = x.Id;
                    replace.cost = x.cost == null ? 0 : x.cost;
                    replace.comment = x.comment != null ? x.comment : "";
                    replace.date = this.eventDate;
                    replace.downTimeHrs =
                      this.downtimeHrs != null ? this.downtimeHrs : 0;
                    replace.smu = this.currentSmu;
                    replace.labourHrs = x.LabourHrs;
                    replace.labourCost = x.LabourCost;
                    replace.parts = x.PartCost;
                    replace.misc = x.MiscCost;
                    replace.planned = x.Planned;
                    replace.equipmentId = this.equipmentId;
                    replace.DateUTC = new Date().toISOString();
                    console.log("recordReplaceData1", replace);
                    const response = await this._inventoryService
                      .replaceComponent(replace)
                      .toPromise();
                    if (response == false) {
                      x.ActionSucess = 2;
                      this.savingChanges = false;
                      console.log("ErrorPerformAction", x.ActionSucess);
                    } else if (response == true) {
                      x.ActionSucess = 1;

                      this.toastr.success("Implement action saved.");
                      console.log("PerformAction", x.ActionSucess);
                    }
                    return response;
                  },
                );
                Promise.all(compReplaceRes).then((repairComp) => {
                  const compRepaireRes = this.arr_RepaprComponents.map(
                    async (x) => {
                      let replace = new ComponentRepairData();
                      replace.componentId = x.Id;
                      replace.cost = x.cost != null ? x.cost : 0;
                      replace.comment = x.comment != null ? x.comment : "";
                      replace.date = this.eventDate;
                      replace.downTimeHrs =
                        this.downtimeHrs != null ? this.downtimeHrs : 0;
                      replace.smu = this.currentSmu;
                      replace.labourHrs = x.LabourHrs;
                      replace.labourCost = x.LabourCost;
                      replace.parts = x.PartCost;
                      replace.misc = x.MiscCost;
                      replace.planned = x.Planned;
                      replace.equipmentId = this.equipmentId;
                      replace.DateUTC = new Date().toISOString();
                      console.log("recordRepaireData1", replace);
                      //repairComponentAssetRepair
                      const response = await this._inventoryService
                        .repairComponent(replace)
                        .toPromise();
                      if (response == false) {
                        x.ActionSucess = 2;
                        this.savingChanges = false;
                        console.log("ErrorPerformAction", x.ActionSucess);
                      } else if (response == true) {
                        x.ActionSucess = 1;
                        console.log("PerformAction", x.ActionSucess);
                      }
                      return response;
                    },
                  );
                  Promise.all(compRepaireRes).then((repairComp) => {
                    this.recalculateImplementAndComponentsLife(
                      this.data.implementId,
                      this.eventDate,
                    );
                    this.dialogRef.close();
                  });
                });
              } else {
                this.toastr.error(succeeded.m_Item2);
              }
            });
        } else {
          this.arr_ReplaceComponents = this.componentList.filter(
            (x) => x.selectComp == true && x.ActionId == 1,
          );
          this.arr_RepaprComponents = this.componentList.filter(
            (x) => x.selectComp == true && x.ActionId == 2,
          );

          const compReplaceRes = this.arr_ReplaceComponents.map(async (x) => {
            let replace = new ComponentRepairData();
            replace.componentId = x.Id;
            replace.cost = x.cost == null ? 0 : x.cost;
            replace.comment = x.comment != null ? x.comment : "";
            replace.date = this.eventDate;
            replace.downTimeHrs =
              this.downtimeHrs != null ? this.downtimeHrs : 0;
            replace.smu = this.currentSmu;
            replace.labourHrs = 0;
            replace.labourCost = 0;
            replace.parts = 0;
            replace.misc = 0;
            replace.DateUTC = new Date().toISOString();
            console.log("recordReplaceData1", replace);
            const response = await this._inventoryService
              .replaceComponent(replace)
              .toPromise();
            if (response == false) {
              x.ActionSucess = 2;
              this.savingChanges = false;
              console.log("ErrorPerformAction", x.ActionSucess);
            } else if (response == true) {
              x.ActionSucess = 1;
              console.log("PerformAction", x.ActionSucess);
            }
            return response;
          });
          Promise.all(compReplaceRes).then((repairComp) => {
            const compRepaireRes = this.arr_RepaprComponents.map(async (x) => {
              let replace = new ComponentRepairData();
              replace.componentId = x.Id;
              replace.cost = x.cost != null ? x.cost : 0;
              replace.comment = x.comment != null ? x.comment : "";
              replace.date = this.eventDate;
              replace.downTimeHrs =
                this.downtimeHrs != null ? this.downtimeHrs : 0;
              replace.smu = this.currentSmu;
              replace.labourHrs = 0;
              replace.labourCost = 0;
              replace.parts = 0;
              replace.misc = 0;
              replace.DateUTC = new Date().toISOString();
              console.log("recordRepaireData1", replace);
              const response = await this._inventoryService
                .repairComponent(replace)
                .toPromise();
              if (response == false) {
                x.ActionSucess = 2;
                this.savingChanges = false;
                //this.toastr.success("Failed to Implement action.");
                console.log("ErrorPerformAction", x.ActionSucess);
              } else if (response == true) {
                x.ActionSucess = 1;
                this.toastr.success("Implement Action Saved");
                console.log("PerformAction", x.ActionSucess);
              }
              return response;
            });

            Promise.all(compRepaireRes).then((repairComp) => {
              this.recalculateImplementAndComponentsLife(
                this.data.implementId,
                this.eventDate,
              );
              this.dialogRef.close();
            });
          });
        }
      }
    }
  }
  saveChanges(): void {
    if (this.savingChanges) {
      return;
    }

    let validation = this.validateData();
    this.savingChanges = true;

    if (validation == ErrorCode.VALIDATION_PASSED) {
      // this.updateSMU();

      let updateModel = new UpdateSMUReadingModel();
      updateModel.currentReading = this.currentSmu;
      updateModel.dateReadSMU = this.eventDate;
      updateModel.equipmentId = this.equipmentId;
      updateModel.startDate = this.eventDate;
      updateModel.endDate = this.eventDate;
      updateModel.bcm = 0;
      updateModel.ton = 0;
      console.log("UpdateSMu", updateModel);

      if (this.equipmentId > 0) {
        this._equipment.changeSMUReading(updateModel).subscribe((succeeded) => {
          if (succeeded.m_Item1) {
            this.SMUupdateSucess = true;
            //this.toastr.success('Meter Reading updated', 'This equipment meter reading has been successfully changed to ' + updateModel.currentReading + '.');
            // this.dialogRef.close(succeeded.m_Item1);

            if (this.actionType == 1 && this.SMUupdateSucess == true) {
              console.log("recordReplaceData1", this.recordReplaceData);
              this._inventoryService
                .replaceComponent(this.recordReplaceData)
                .subscribe(
                  (response) => {
                    if (response == false) {
                      this.toastr.error(ErrorMessages.ERROR_SAVING);
                      this.savingChanges = false;
                    } else {
                      this.toastr.success("Implement Action Saved");
                      console.log("saved and update SMU");
                      //this.updateSMU();
                      this.dialogRef.close();
                    }
                  },
                  (error) => {
                    console.log(error);
                  },
                );
            } else if (this.actionType == 2 && this.SMUupdateSucess == true) {
              this._inventoryService
                .repairComponent(this.recordRepairData)
                .subscribe(
                  (response) => {
                    if (response == false) {
                      this.toastr.error(ErrorMessages.ERROR_SAVING);
                      this.savingChanges = false;
                    } else {
                      this.toastr.success("Implement Action Saved");
                      console.log("saved and update SMU");
                      // this.updateSMU();
                      this.dialogRef.close();
                    }
                  },
                  (error) => {
                    console.log(error);
                  },
                );
            }
          } else {
            this.SMUupdateSucess = false;
            //this.dialogRef.close(succeeded.m_Item2);
            this.toastr.error(succeeded.m_Item2);
          }
        });
      } else {
        this.recordRepairData.smu = 0;
        this.recordReplaceData.smu = 0;
        console.log("recordReplaceData", this.recordReplaceData);
        if (this.actionType == 1) {
          console.log("save replacement data", this.recordReplaceData);
          this._inventoryService
            .replaceComponent(this.recordReplaceData)
            .subscribe(
              (response) => {
                if (response == false) {
                  this.toastr.error(ErrorMessages.ERROR_SAVING);
                  this.savingChanges = false;
                } else {
                  this.toastr.success("Implement Action Saved");
                  console.log("saved and update SMU");
                  //this.updateSMU();
                  this.dialogRef.close();
                }
              },
              (error) => {
                console.log(error);
              },
            );
        } else if (this.actionType == 2) {
          this._inventoryService
            .repairComponent(this.recordRepairData)
            .subscribe(
              (response) => {
                if (response == false) {
                  this.toastr.error(ErrorMessages.ERROR_SAVING);
                  this.savingChanges = false;
                } else {
                  this.toastr.success("Implement Action Saved");
                  console.log("saved and update SMU");
                  // this.updateSMU();
                  this.dialogRef.close();
                }
              },
              (error) => {
                console.log(error);
              },
            );
        }
      }
    } else if (validation == ErrorCode.ERROR_NEGATIVE_COST) {
      this.toastr.error(ErrorMessages.ERROR_NEGATIVE_COST);
      this.savingChanges = false;
    } else {
      console.log("erro");
      this.toastr.error(ErrorMessages.ERROR_MISSING_FIELDS);
      this.savingChanges = false;
    }
  }

  validateData_New(): number {
    var returnCode = ErrorCode.ERROR_MISSING_FIELDS;
    console.log(
      "this.selectedImplement, this.equipmentId, this.currentSmu, setupDateParts",
      this.selectedImplement,
      this.equipmentId,
      this.currentSmu,
      setupDateParts,
    );
    var setupDateParts =
      this.eventDate.getDate() +
      "/" +
      (this.eventDate.getMonth() + 1) +
      "/" +
      this.eventDate.getFullYear();
    var vEquipmentSMU = this._implementService.ValidateEquipmentSMUAtSetup(
      this.selectedImplement,
      this.equipmentId,
      this.currentSmu,
      setupDateParts,
    );
    if (vEquipmentSMU) {
      returnCode = ErrorCode.VALIDATION_PASSED;
    } else {
      returnCode = ErrorCode.ERROR_SMU;
    }

    return returnCode;
  }
  validateData(): number {
    console.log("Cost", this.recordReplaceData);
    var returnCode = ErrorCode.ERROR_MISSING_FIELDS;
    if (this.actionType == 1) {
      if (this.recordReplaceData.componentId && this.recordReplaceData.date) {
        if (this.recordReplaceData.cost < 0) {
          returnCode = ErrorCode.ERROR_NEGATIVE_COST;
        } else {
          returnCode = ErrorCode.VALIDATION_PASSED;
        }
      }
    } else if (this.actionType == 2) {
      if (this.recordRepairData.componentId && this.recordRepairData.date) {
        if (this.recordRepairData.cost < 0) {
          returnCode = ErrorCode.ERROR_NEGATIVE_COST;
        } else {
          returnCode = ErrorCode.VALIDATION_PASSED;
        }
      }
    }

    if (this.equipmentId > 0) {
      console.log(
        "this.selectedImplement, this.equipmentId, this.currentSmu, setupDateParts",
        this.selectedImplement,
        this.equipmentId,
        this.currentSmu,
        setupDateParts,
      );
      var setupDateParts =
        this.eventDate.getDate() +
        "/" +
        (this.eventDate.getMonth() + 1) +
        "/" +
        this.eventDate.getFullYear();
      var vEquipmentSMU = this._implementService.ValidateEquipmentSMUAtSetup(
        this.selectedImplement,
        this.equipmentId,
        this.currentSmu,
        setupDateParts,
      );
      if (vEquipmentSMU) {
        returnCode = ErrorCode.VALIDATION_PASSED;
      } else {
        returnCode = ErrorCode.ERROR_SMU;
      }
    }

    return returnCode;
  }

  implementSelected() {
    //this.selectedImplement = v;
    this.loadComponentTypes();
    this._implementService
      .ReturnGETComponents(this.selectedImplement)
      .subscribe((result) => {
        //this.componentList = result;
        //this.CopycomponentList = this.componentList;
        this.CopycomponentList = result;
      });
  }

  //Component Type For Implements
  loadComponentTypes() {
    // this._implementService.GetComponentTypeListForSelectedImplement(this.selectedImplement).subscribe(r => {
    this._implementService
      .GetMasterComponentTypeList(this.selectedImplement)
      .subscribe((r) => {
        this.componentTypes = r;
        if (this.removeActionData) {
          this.loadPendingActionData();
        }
      });
  }

  //ChangecomponentType() {

  //    let arr = [];
  //    this.componentList = this.CopycomponentList;
  //    console.log("componentlist", this.componentList)
  //    if (this.selectedComponentType.length > 0) {
  //        this.selectedComponentType.map(x => {
  //            this.componentList.map(c => {
  //                if (c.CompTypeId == x) {
  //                    if (arr.length == 0) {
  //                        c.ActionId = 2;
  //                        arr.push(c);
  //                    } else {
  //                        let info = arr.find(y => y.Id == c.Id);
  //                        if (info == null) {
  //                            c.ActionId = 2;
  //                            arr.push(c);
  //                        }
  //                    }
  //                }
  //            })
  //            //let data_ = this.componentList.find(c => c.CompTypeId == x);

  //        })
  //        this.componentList = arr;
  //    } else {
  //        this.componentList = [];
  //    }

  //}

  ChangecomponentType(newSelected?: any[]) {
    const rawSelected = Array.isArray(newSelected)
      ? newSelected
      : this.selectedComponentType || [];
    const selectedTypes = new Set(rawSelected.map((v) => String(v)));
    const source = this.CopycomponentList || []; // full data set
    const prevDest = this.componentList || []; // current destination (what user sees)
    const keyOf = (x: any) => String(x?.Id);
    const prevByKey = new Map(prevDest.map((x) => [keyOf(x), x]));
    if (selectedTypes.size === 0) {
      this.componentList = [];
      return;
    }
    const result: any[] = [];
    const seen = new Set<string>();
    for (const c of source) {
      if (!c) continue;
      const key = keyOf(c);
      if (!key || c.CompTypeId == null) continue;
      const compTypeKey = String(c.CompTypeId);
      if (!selectedTypes.has(compTypeKey)) continue;
      if (seen.has(key)) continue;
      seen.add(key);
      const prev = prevByKey.get(key);
      const item = { ...c };
      if (prev && prev.ActionId !== undefined && prev.ActionId !== null) {
        item.ActionId = prev.ActionId;
      } else {
        item.ActionId = 2;
      }
      if (prev) {
        item.selectComp = prev.selectComp;
        item.LabourHrs = prev.LabourHrs;
        item.LabourCost = prev.LabourCost;
        item.PartCost = prev.PartCost;
        item.MiscCost = prev.MiscCost;
        item.cost = prev.cost;
        item.comment = prev.comment;
        item.Planned = prev.Planned;
        item.ActionSucess = prev.ActionSucess;
        item.ActionMinDate = prev.ActionMinDate;
      }
      result.push(item);
    }
    this.componentList = result;
  }

  trackById(index: number, item: any) {
    return item?.Id; // stable key
  }

  componentSelected(v) {
    this.selectedComponent = v;
    this.recordRepairData.componentId = this.selectedComponent;
    this.recordReplaceData.componentId = this.selectedComponent;

    this._inventoryService
      .returnMinDateForComponentReplace(this.selectedComponent.toString())
      .subscribe((response) => {
        if (response != "") {
          try {
            this.minDate1 = new Date(response);
          } catch (ex) {
            this.minDate1 = new Date();
          } finally {
            this.minDateForAction = this.minDate1;
          }
        }
      });

    //this._inventoryService.returnMinDateForComponentRepair(this.selectedComponent.toString())
    // this._inventoryService.returnMinDateForComponentReplace(this.selectedComponent.toString())
    //     .subscribe(response => {
    //         if (response != "") {
    //             try {
    //                 this.minDate2 = new Date(response);
    //             }
    //             catch (ex) {
    //                 this.minDate2 = new Date();
    //             } finally {
    //                 if (this.actionType == 2) {
    //                     this.minDateForAction = this.minDate2;
    //                 }
    //             }
    //         }
    //     });
  }

  //SMU
  smuChange(): void {
    this.recordReplaceData.smu = this.currentSmu;
    this.recordRepairData.smu = this.currentSmu;
  }

  // Cost
  costChanged(): void {
    this.recordReplaceData.cost = this.cost != null ? this.cost : 0;
    this.recordRepairData.cost = this.cost != null ? this.cost : 0;
  }

  // Date
  dateChanged(): void {
    this.recordReplaceData.date = this.eventDate;
    this.recordRepairData.date = this.eventDate;
    this.ord.formatDateOrdinal(
      this.eventDate.toString().split(" ").slice(1).join(" "),
      false,
    );

    this.componentList.map((x) => {
      if (x.selectComp == true && x.ActionSucess == -1) {
        x.selectComp = false;
        this.DisabledSaveButton = false;
      }
    });
  }

  //DownTimeHrs
  downtimeHrsChanged() {
    this.recordReplaceData.downTimeHrs = this.downtimeHrs;
  }

  // Comment
  commentChanged(): void {
    this.recordReplaceData.comment = this.comment;
    this.recordRepairData.comment = this.comment;
  }

  DisabledSaveButton: boolean = false;
  //new code
  onComponentListControlChanged(id, name, comp: ComponentVM) {
    let selectedComp_ = this.componentList.find((x) => x.Id == id);
    if (selectedComp_.selectComp == true) {
      selectedComp_.selectComp = false;
      selectedComp_.Planned = false;
    } else {
      selectedComp_.selectComp = true;
      selectedComp_.Planned = true;
      //this.componentSelected(id);
      this._inventoryService
        .returnMinDateForComponentReplace(id.toString())
        .subscribe((response) => {
          if (response != "") {
            try {
              this.minDate1 = new Date(response);
              if (this.eventDate < this.minDate1) {
                // console.log("this.action__", this.minDate1, this.eventDate)

                comp.ActionSucess = -1;
                comp.ActionMinDate = this.minDate1;
                comp.Error = "Action date should be greater than ";
                this.DisabledSaveButton = true;
                return;
              } else {
                comp.ActionSucess = 0;
                comp.ActionMinDate = null;
                comp.Error = "";
              }
            } catch (ex) {
              this.minDate1 = new Date();
            } finally {
              // this.minDateForAction = this.minDate1;
            }
          }
        });
    }
    this.totalcost = 0;
    this.totalLabour = 0;
    this.totalMisc = 0;
    this.totalparts = 0;
    this.totalHrs = 0;
    this.componentList.map((x) => {
      if (x.selectComp == true) {
        // this.totalcost = this.totalcost + x.cost;
        this.totalLabour = this.totalLabour + x.LabourCost;
        this.totalMisc = this.totalMisc + x.MiscCost;
        this.totalparts = this.totalparts + x.PartCost;
        this.totalcost = this.totalLabour + this.totalMisc + this.totalparts;
        this.totalHrs = this.totalHrs + x.LabourHrs;

        this.calculateDifferenceLabourCost();
        this.calculateDifferencePartCost();
        this.calculateDifferenceMiscCost();
        this.calculateDifferenceLabourHours();
      }
    });
  }

  calculateDifferenceLabourHours() {
    this.DLabour_Hours =
      this.TLabour_Hours > 0 ? this.TLabour_Hours - this.totalHrs : 0;
    console.log("TLabour_Hours", this.TLabour_Hours, this.totalHrs);
    if (
      this.DLabour_Hours != 0 ||
      this.DLabour_Cost != 0 ||
      this.DPart_Cost != 0 ||
      this.DMisc_Cost != 0
    ) {
      this.hasDiffernce = true;
    } else {
      this.hasDiffernce = false;
    }
  }
  calculateDifferenceLabourCost() {
    this.DLabour_Cost =
      this.TLabour_Cost > 0 ? this.TLabour_Cost - this.totalLabour : 0;
    this.TTotal_Cost = this.DLabour_Cost + this.DPart_Cost + this.DMisc_Cost;
    this.calculateDifferenceTotalCost();

    console.log(
      "TLabour_Cost",
      this.TLabour_Cost,
      this.totalLabour,
      this.DLabour_Cost,
    );
    if (
      this.DLabour_Hours != 0 ||
      this.DLabour_Cost != 0 ||
      this.DPart_Cost != 0 ||
      this.DMisc_Cost != 0
    ) {
      this.hasDiffernce = true;
    } else {
      this.hasDiffernce = false;
    }
  }
  calculateDifferencePartCost() {
    this.DPart_Cost =
      this.TPart_Cost > 0 ? this.TPart_Cost - this.totalparts : 0;
    this.TTotal_Cost = this.DLabour_Cost + this.DPart_Cost + this.DMisc_Cost;
    this.calculateDifferenceTotalCost();
    if (
      this.DLabour_Hours != 0 ||
      this.DLabour_Cost != 0 ||
      this.DPart_Cost != 0 ||
      this.DMisc_Cost != 0
    ) {
      this.hasDiffernce = true;
    } else {
      this.hasDiffernce = false;
    }
  }
  calculateDifferenceMiscCost() {
    this.DMisc_Cost =
      this.TMisc_Cost > 0 ? this.TMisc_Cost - this.totalMisc : 0;
    this.TTotal_Cost = this.DLabour_Cost + this.DPart_Cost + this.DMisc_Cost;
    this.calculateDifferenceTotalCost();
    if (
      this.DLabour_Hours != 0 ||
      this.DLabour_Cost != 0 ||
      this.DPart_Cost != 0 ||
      this.DMisc_Cost != 0
    ) {
      this.hasDiffernce = true;
    } else {
      this.hasDiffernce = false;
    }
  }
  calculateDifferenceTotalCost() {
    this.DTotal_Cost =
      this.TTotal_Cost > 0 ? this.TTotal_Cost - this.totalcost : 0;
  }

  calculateTotalCost(comp: ComponentVM) {
    comp.cost = comp.PartCost + comp.MiscCost + comp.LabourCost;
    this.totalcost = 0;
    this.totalLabour = 0;
    this.totalMisc = 0;
    this.totalparts = 0;
    console.log("list__", this.componentList);
    this.componentList.map((x) => {
      if (x.selectComp == true) {
        // this.totalcost = this.totalcost + x.cost;
        this.totalLabour = this.totalLabour + x.LabourCost;
        this.totalMisc = this.totalMisc + x.MiscCost;
        this.totalparts = this.totalparts + x.PartCost;
        this.totalcost = this.totalLabour + this.totalMisc + this.totalparts;

        this.calculateDifferenceLabourCost();
        this.calculateDifferencePartCost();
        this.calculateDifferenceMiscCost();
      }
    });
  }

  calculateTotalHrs(comp: ComponentVM) {
    this.totalHrs = 0;
    this.componentList.map((x) => {
      if (x.selectComp == true) {
        this.totalHrs = this.totalHrs + x.LabourHrs;
        this.calculateDifferenceLabourHours();
      }
    });
  }

  recalculateImplementAndComponentsLife(implementId: number, eventDate: Date) {
    //console.log("this.Implemetdetails.Id:", this.Implemetdetails.Id);
    this._moduleService
      .checkAndRecalculateImplementAndComponentsLife(implementId, eventDate)
      .subscribe((res) => {});
  }
}
